export enum LocalesEnum {
    En = "en-BE",
    Fr = "fr-BE",
    Nl = "nl-BE",
}
